<script>
	import Carousel from 'svelte-carousel';
import { identity } from 'svelte/internal';
	import { get_parameters } from "./helpers";

	const images = [{src:'nl/slideshow/carrousel_img_01.jpg',title:'Landschap'},
	                {src:'nl/slideshow/carrousel_img_03.jpg',title:'Rivier'},
	                {src:'nl/slideshow/carrousel_img_04.jpg',title:'Waterpret'},
	                {src:'nl/slideshow/carrousel_img_05.jpg',title:'Kano'}];

    let portal_url = document.body.dataset && document.body.dataset.portalUrl || 'http://localhost:9291/plone';
	let next_url = "";
	let query = {};
	Object.assign(query, {
		b_size: 30,
		sort_on: "effective",
		sort_order: "descending",
		'path.query': "%2Fplone%2Fnl%2Fslideshow", 
		'path.depth': 1,
		portal_type: ['Image']
	});


	async function getImages() {
		// Always make next_url empty.
		// This avoids running two searches at the same time.
		let next_url = "";
		let results = {};
		let items = [];
		let search_url = portal_url + "/@search"

		let parameters = get_parameters(query);
		search_url += "?" + parameters.join("&");
		console.log(search_url);
		const res = await fetch(search_url, {
		headers: new Headers({ Accept: "application/json" }),
		});
		results = await res.json();
		if (!results.batching) {
		items = results.items;
		next_url = "";
		} else {
		// Add new items to current items.
		items = [...items, ...results.items];
		next_url = results.batching.next;
		}
		return items;
	};

	let plone_images = getImages();

</script>

<main>

	{#await plone_images}
	<p>...waiting</p>
	{:then items}
	<Carousel autoplay={true}
	autoplayDuration={3500}
	let:loaded
	>
	<div slot="prev">
    	<!-- -->
	</div>
	<div slot="next">
		<!-- -->
	</div> 
	<div slot="dots">
		<!-- -->
	</div> 

	{#each Object.entries(items) as [id, item], imageIndex (item['@id']) }
			<div class="img-container">
				{#if loaded.includes(imageIndex)}
				<img src={item['@id']} alt={item["title"]} />
			    {/if}
				<div class="img-caption"><span>{item["title"]}</span></div>
			</div>
		{/each}
		</Carousel>
	{:catch error}
		<p style="color: red">{error.message}</p>
	{/await}
</main>
<style>
	main {
		text-align: center;
		margin: 0 auto;
		padding: 0 1em;
	}
	.img-caption {
		position: absolute;
		bottom: 0px;
		min-width: 100%;
		padding-top: 3px;
		padding-bottom: 5px;
		color: white;
		font-weight: 200;
		height: 30px;
		background-color: rgba(0,0,0,0.4);
		display:none;
	}
	.img-container:hover .img-caption {
		display: block;
	}
</style>